<template>
  <div style="margin:20px">
    <FiPageRail title="Actuals - Mileage By Booking Report" />

    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
        <b-button v-on:click.prevent="load_data(false)" :disabled="loading">Get Results</b-button>
        &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      Filter&nbsp;<b-form-input style="width: 200px" v-model="booking_filter" placeholder="bookingID,vehicle,driver"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
        <b-button size="md" variant="success" :disabled="loading" @click="download">Download Report</b-button>
    </div>

    <div v-if="!loading && items_full.length > 0">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div v-if="summary.total_cnt" class="col" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
      </div>
    </div>

    <table v-if="!loading && items.length > 0" width="100%" border="1" cellpadding="2">
      <thead>
        <tr class="stripe">
          <th width="60px" @click="sort_numbers('bookingID')">Booking ID</th>
          <th width="60px" @click="sort_strings('drivers')">Drivers</th>
          <th width="60px" @click="sort_strings('vehicles')">Vehicles</th>
          <th width="60px" @click="sort_dates('plannedStartDateTime')">Start</th>
          <th width="60px" @click="sort_dates('plannedFinishDateTime')">Finish</th>
          <th width="60px" @click="sort_numbers('actualTotalDistance')">Mileage</th>
          <th width="200px" @click="sort_strings('status')">Status</th>
        </tr>
      </thead>
      <template v-for="item in items">
        <tr class="stripe">
          <td>{{ item.bookingID }}</td>
          <td>{{ item.drivers }}</td>
          <td>{{ item.vehicles }}</td>
          <td>{{item.plannedStartDateTime | formatDateTimeSmall}}</td>
          <td>{{item.plannedFinishDateTime | formatDateTimeSmall}}</td>
          <td>{{item.actualTotalDistance | units('m')}}</td>
          <td>{{item.status}}</td>
        </tr>
      </template>
    </table>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_actuals_mileage_by_booking_report } from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_mileage_by_booking_report',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(180, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {

  },
  methods: {
    async load_data(reprocess) {
      this.loading = true
      try {
        const {value: {data = []}} = await get_actuals_mileage_by_booking_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.loading = false
      } catch(e) {
        this.summary = []
        this.items = []
        this.items_full = []
        this.$emit('showAlert', "your request is taking longer than expected, please use 'Get Results' to retrieve processed results in a few minutes", 'warning', 30000)
        this.loading = false
      }
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    },
    filter_items() {
      this.items = this.items_full
      if (this.booking_filter)
        this.items = this.items.filter(item => this.contains(item.bookingID,this.booking_filter) || this.contains(item.drivers, this.booking_filter) || this.contains(item.vehicles,this.booking_filter))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info')
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/actuals/mileage_by_booking/download`,
          {
            tenant: this.user.tenant,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `mileage-report-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.items = []
        this.items_full = []
        this.summary = null
        this.load_drivers()
      }
    },
    // details_fromDate(target_from_date) {
    //   this.details_fromDate = target_from_date
    //   if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
    //     this.details_toDate = this.details_fromDate
    //
    //   const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
    //   if (days > 100) {
    //     alert("please limit tag based date range to 3 months or less")
    //     this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(30, 'days'))
    //   }
    // },
    booking_filter() {
      this.filter_items()
    }
  }
}
</script>

<style scoped>

thead {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border: 1px solid black;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }


</style>
